import { render, staticRenderFns } from "./DiscordConfirm.vue?vue&type=template&id=01e87f73&scoped=true&"
import script from "./DiscordConfirm.vue?vue&type=script&lang=ts&"
export * from "./DiscordConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./DiscordConfirm.vue?vue&type=style&index=0&id=01e87f73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e87f73",
  null
  
)

export default component.exports